import React from 'react';
import POItemViewerBody from './POItemViewerBody';
import POAttachmentsViewer from './POAttachmentsViewer';
import {useAuth} from '@/context/AuthProvider';
import {useProcurementOperationalContext} from '@/hooks/useProcurementOperationalContext';
import {procurementContextKey} from '@/lib/procurementAssistantRequests';

export default function POItemViewer(props) {
  const {user}=useAuth();
  const operational=useProcurementOperationalContext(user,Boolean(user));
  if(operational.loading)return <p role="status">Loading selected company and unit…</p>;
  if(operational.error)return <p role="alert">{operational.error}</p>;
  const key=procurementContextKey(operational.expected);
  if(!key)return <p role="alert">Select a company and unit before opening this PO.</p>;
  return <>
    {operational.refreshing&&<p role="status">Checking selected company and unit…</p>}
    <div hidden={operational.refreshing} inert={operational.refreshing?'':undefined}>
      <ScopedViewer key={`${key}:${props.poId}`} {...props} expectedUser={operational.expected}/>
    </div>
  </>;
}
function ScopedViewer(props) {
  return <>
    <POItemViewerBody {...props} />
    <POAttachmentsViewer poId={props.poId} />
  </>;
}
